import React, { useEffect, useState } from 'react';
import MetaTags from 'react-meta-tags';
import {
  Card,
  CardBody,
  CardHeader,
  CardText,
  CardTitle,
  Col,
  Collapse,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
  NavLink,
  Row,
  Spinner,
  TabContent,
  TabPane,
  FormGroup,
  Label,
  Button,
  Input,
  Form,
  Table,
  UncontrolledDropdown,
} from 'reactstrap';
import { DashBreadcrumb } from '../../../../components/Common/Breadcrumb';
import {
  fetchCreateReturnDetailWarehouse,
  fetchOrderWarehouseReturnDetail,
} from '../../actions/orderActions';
import { useLazyQuery } from '@apollo/client';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRefundDetail } from '../../../Refunds/action/action';
import toast, { Toaster } from 'react-hot-toast';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { useHistory } from 'react-router-dom';
import ReactDrawer from 'react-drawer';
import classnames from 'classnames';
import Dropzone from 'react-dropzone';
const CreateFormReturnWarehouse = () => {
  const dispatch = useDispatch();
  const [position, setPosition] = useState();
  const [updateStsLoad, setUpdateDetailsLoad] = useState(false);
  const [open, setOpen] = useState(false);
  const [stErr, setStErr] = useState(0);
  const [selectedFiles, setselectedFiles] = useState([]);
  const [verticalActiveTab, setverticalActiveTab] = useState('1');
  const history = useHistory();
  const [selectedItemForReturn, setSelectedItemForReturn] = useState(null);
  const [counter, setCounter] = useState(0);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [headerTab, setHeaderTab] = useState('1');
  const [headerPillsTab, setHeaderPillsTab] = useState('1');
  const [errorMessage, setErrorMessage] = useState(null);
  const [errorMessageCounter, setErrorMessageForCounter] = useState(null);
  const { country = [] } = useSelector((state) => state.country);
  const [loading, setLoading] = useState(false);

  const [paymentMode, setPaymentMode] = useState('');

  const handlePaymentChange = (event) => {
    setPaymentMode(event.target.value);
    console.log(event.target.value);
  };
  const toggleHeader = (tab) => {
    if (headerTab !== tab) setHeaderTab(tab);
  };
  const toggleHeaderPills = (tab) => {
    if (headerPillsTab !== tab) setHeaderPillsTab(tab);
  };

  const toggleVertical = (tab) => {
    if (verticalActiveTab !== tab) {
      setverticalActiveTab(tab);
    }
  };
  const toggleRightDrawer = () => {
    setPosition('right');
    setOpen(!open);
  };
  const onDrawerClose = () => {
    setOpen(false);
  };
  function handleAcceptedFiles(files) {
    setErrorMessage(null);
    let images = [...selectedFiles, ...files];
    let previewImages = [];
    images.map((file, index) => {
      previewImages.push(URL.createObjectURL(file));
    });
    if (images.length > 5) {
      setErrorMessage('More than 5 images not allowed');
    }
    setImagePreviews(previewImages);
    setselectedFiles(images);
  }

  const incrementCounter = (qty) => {
    if (counter < qty) {
      setCounter(counter + 1);
    } else {
      // console.log("Return quantity is more then order Quantity");
    }
  };

  const decrementCounter = () => {
    if (counter > 1) {
      setCounter(counter - 1);
    }
  };
  // if (counter <= 1) {
  //   decrementCounter = () => {
  //     setCounter(1);
  //   };
  // }

  const handleReturnSubmit = async (event, values) => {
    console.log(values, 'values');
    const reference_no = values?.reference_no ? values?.reference_no : '';
    setLoading(true);
    await fetchOrderWarehouseReturnDetail({
      params: {
        reference_no: reference_no,
      },
      dispatch,
    });
    setLoading(false);
  };

  const { orderDetailReturn, isOrderReturnDetailLoading } = useSelector(
    (state) => state.order
  );
  const handleValidSubmit = (events, value) => {
    console.log(counter, 'counter ');

    setUpdateDetailsLoad(true);
    const form = events.currentTarget;
    const formData = new FormData();
    selectedFiles.map((file, index) => {
      formData.append(`upload_image[${index}]`, file);
    });

    formData.append('order_id', selectedItemForReturn?.OrderRef);
    formData.append('item_sku', selectedItemForReturn?.Sku);
    formData.append('ordered_item_qty', selectedItemForReturn?.Qty);
    formData.append('return_item_qty', counter);
    formData.append('item_condition', events.target.Ic.value);
    formData.append('return_reason', events.target.rr.value);
    formData.append('return_comments', events.target.return_comment.value);
    formData.append('country', country);
    formData.append('approved_payment_mode', events.target.payment_mode.value);
    //formData.append("time_slot", events.target.time_slot.value?events.target.time_slot.value:'');
    fetchCreateReturnDetailWarehouse({
      formData,

      dispatch,
    });
  };
  const { createReturn = [], isReturnDetailLoading } = useSelector(
    (state) => state.order
  );
  useEffect(() => {
    if (createReturn?.code === 100) {
      setUpdateDetailsLoad(false);
      toast.success(createReturn?.message, {
        style: {
          border: '1px solid #fff',
          padding: '20px',
          color: '#ffffff',
          background: '#4CAF50',
        },
        iconTheme: {
          primary: '#FFFAEE',
          secondary: '#4CAF50',
        },
      });
      setTimeout(() => {
        history.push('/ReturnApprovedOrders');
      }, 10);
    } else {
      if (createReturn?.message) {
        setUpdateDetailsLoad(false);
        toast.error(createReturn?.message, {
          style: {
            border: '1px solid #fff',
            padding: '20px',
            color: '#ffffff',
            background: '#f44336',
          },
          iconTheme: {
            primary: '#FFFAEE',
            secondary: '#f44336',
          },
        });
        onDrawerClose();
      }
    }
  }, [createReturn]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl={9}>
              <DashBreadcrumb
                title="Orders"
                breadcrumbItem="Create Return Orders"
              />
            </Col>
            <Col>
              <AvForm
                className="needs-validation"
                onValidSubmit={(e, v) => {
                  handleReturnSubmit(e, v);
                }}
              >
                <div className="position-relative">
                  <AvField
                    name="reference_no"
                    className="form-control"
                    placeholder="Search for ERP Order NO"
                    type="text"
                    value=""
                    required
                  />
                  <Button
                    color="primary"
                    type="submit"
                    className="position-absolute top-0 end-0"
                    disabled={loading ? true : null}
                  >
                    <i className="bx bx-search-alt align-middle"></i>{' '}
                    {loading ? 'loading' : null}
                  </Button>
                </div>
              </AvForm>
            </Col>
          </Row>
          {loading ? (
            <Row>
              <Col md={6} xl={4}>
                <Card>
                  <CardBody>
                    <p className="placeholder-glow d-flex flex-column gap-1">
                      <span className="placeholder col-6"></span>
                      <span className="placeholder w-75"></span>
                      <span
                        className="placeholder"
                        style={{ width: '25%' }}
                      ></span>
                    </p>
                  </CardBody>
                </Card>
              </Col>

              <Col md={6} xl={4}>
                <Card>
                  <CardBody>
                    <p className="placeholder-glow d-flex flex-column gap-1">
                      <span className="placeholder col-6"></span>
                      <span className="placeholder w-75"></span>
                      <span
                        className="placeholder"
                        style={{ width: '25%' }}
                      ></span>
                    </p>
                  </CardBody>
                </Card>
              </Col>

              <Col md={6} xl={4}>
                <Card>
                  <CardBody>
                    <p className="placeholder-glow d-flex flex-column gap-1">
                      <span className="placeholder col-6"></span>
                      <span className="placeholder w-75"></span>
                      <span
                        className="placeholder"
                        style={{ width: '25%' }}
                      ></span>
                    </p>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          ) : orderDetailReturn?.code === 100 ? (
            <>
              <Row>
                <Col md={6} xl={4}>
                  <Card>
                    <CardHeader className="bg-light">
                      <CardTitle>ORDER DETAILS</CardTitle>
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col>
                          <span className="mb-2 text-muted text-uppercase font-size-11 ">
                            Order Number
                          </span>
                        </Col>
                        <Col>
                          <h6 className="fw-medium textAlignRight">
                            {orderDetailReturn?.OrderDetails?.[0]?.OrderNo}
                          </h6>
                        </Col>
                      </Row>

                      <Row>
                        <Col>
                          <span className="mb-2 text-muted text-uppercase font-size-11">
                            Order Date
                          </span>
                        </Col>
                        <Col>
                          <h6 className="fw-medium textAlignRight">
                            {orderDetailReturn?.OrderDetails?.[0]?.CreatedDate}
                            <br />
                          </h6>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
                <Col md={6} xl={4}>
                  <Card>
                    <CardHeader className="bg-light p-3">
                      <CardTitle className="m-0">CUSTOMER DETAILS</CardTitle>
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col>
                          <span className="mb-2 text-muted text-uppercase font-size-11">
                            Name
                          </span>
                        </Col>
                        <Col>
                          <h6 className="fw-medium textAlignRight">
                            {orderDetailReturn?.OrderDetails?.[0]?.FullName}
                          </h6>
                        </Col>
                      </Row>

                      <Row>
                        <Col>
                          <span className="mb-2 text-muted text-uppercase font-size-11">
                            Phone Number
                          </span>
                        </Col>
                        <Col>
                          <h6 className="fw-medium textAlignRight ">
                            {orderDetailReturn?.OrderDetails?.[0]?.Phone}
                            <br />
                          </h6>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
                <Col md={6} xl={4}>
                  <Card>
                    <CardHeader className="bg-light p-3">
                      <CardTitle className="m-0">PAYMENT DETAILS</CardTitle>
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col>
                          <span className="mb-2 text-muted text-uppercase font-size-11">
                            Payment Mode
                          </span>
                        </Col>
                        <Col>
                          <h6 className="fw-medium textAlignRight">
                            {orderDetailReturn?.OrderDetails?.[0]?.PaymentMode}
                          </h6>
                        </Col>
                      </Row>

                      <Row>
                        <Col>
                          <span className="mb-2 text-muted text-uppercase font-size-11">
                            Total Paid Amount
                          </span>
                        </Col>
                        <Col>
                          <h6 className="fw-medium textAlignRight ">
                            {orderDetailReturn?.OrderDetails?.[0]?.Currency}{' '}
                            {orderDetailReturn?.OrderDetails?.[0]?.OrderTotal}
                            <br />
                          </h6>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <CardBody className="px-0">
                <div className="table-responsive   dt-table ">
                  <Table className=" table  mb-0 ">
                    <thead>
                      <tr>
                        <th>Details</th>
                        <th className="text-center">Qty</th>
                        <th className="text-center" nowrap="nowrap">
                          Original Price
                        </th>
                        <th className="text-center" nowrap="nowrap">
                          Now Price
                        </th>
                        <th className="text-center" nowrap="nowrap">
                          Discount
                        </th>
                        <th className="text-center" nowrap="nowrap">
                          Total
                        </th>
                        <th className="text-center" nowrap="nowrap"></th>
                      </tr>
                    </thead>

                    <tbody>
                      {orderDetailReturn?.OrderDetails?.[0]?.orderitems.map(
                        (item, itemInx) => {
                          return (
                            <tr key={itemInx}>
                              <td className="table-bordered ProductDetailsSec">
                                <div className="ProductDetails">
                                  <div>
                                    <img
                                      alt=""
                                      width="100"
                                      height="100"
                                      className="img-thumbnail1"
                                      src={item?.Image}
                                    />
                                  </div>
                                  <div className="itemDetail">
                                    <span>{item?.Name}</span>
                                    <span>SKU: {item?.Sku}</span>
                                    <span> LS Ref: {item?.OrderRef}</span>
                                    <span>
                                      Status : <b>{item?.LsStatus}</b>
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td
                                className="table-bordered align-middle text-center"
                                nowrap="nowrap"
                              >
                                {item?.Qty}
                              </td>
                              <td
                                className="table-bordered align-middle text-center"
                                nowrap="nowrap"
                              >
                                {item?.Currency} {item?.WasPrice}
                              </td>
                              <td
                                className="table-bordered align-middle text-center"
                                nowrap="nowrap"
                              >
                                {item?.Currency} {item?.NowPrice}
                              </td>
                              <td
                                className="table-bordered align-middle text-center"
                                nowrap="nowrap"
                              >
                                {item?.Currency} {item?.Discount}
                              </td>
                              <td
                                className="table-bordered align-middle text-center"
                                nowrap="nowrap"
                              >
                                {item?.Currency} {item?.TotalPrice}
                              </td>
                              <td
                                className="table-bordered align-middle text-center"
                                nowrap="nowrap"
                              >
                                <button
                                  className={
                                    item?.ReturnEligible === 1
                                      ? 'btnTracking'
                                      : 'btnTracking1'
                                  }
                                  type="submit"
                                  onClick={() => {
                                    toggleRightDrawer();
                                    setSelectedItemForReturn(item);
                                  }}
                                  disabled={
                                    item?.ReturnEligible === 1 ? open : !open
                                  }
                                >
                                  Make a Return{' '}
                                </button>
                              </td>
                            </tr>
                          );
                        }
                      )}
                    </tbody>
                  </Table>
                </div>
              </CardBody>
              <ReactDrawer
                open={open}
                position={position}
                onClose={onDrawerClose}
                className="sideNavWidth"
              >
                <Card
                  className="card-h-100 OrderDetailsBox"
                  style={{ overflowY: 'scroll' }}
                >
                  <CardHeader style={{ borderBottom: '1px solid #e4e4e4' }}>
                    <Row>
                      <Col>
                        <CardTitle>Return Request</CardTitle>
                      </Col>
                      <Col className="textAlignRight">
                        <button
                          type="button"
                          className="btn-close "
                          onClick={onDrawerClose}
                          aria-label="Close"
                        ></button>
                      </Col>
                    </Row>
                    <Row>
                      <span style={{ paddingRight: '10px' }}>
                        Create your return request
                      </span>
                    </Row>
                  </CardHeader>
                  <CardBody>
                    <AvForm
                      onValidSubmit={(e, v) => {
                        handleValidSubmit(e, v);
                      }}
                    >
                      <div className="ProductDetailsSec">
                        <div
                          className="ProductDetails mb-3 mt-3"
                          nowrap="nowrap"
                        >
                          <div>
                            <img
                              alt=""
                              width="100"
                              height="100"
                              className="img-thumbnail"
                              src={selectedItemForReturn?.Image}
                            />
                          </div>
                          <div className="itemDetail1">
                            <span>{selectedItemForReturn?.Name}</span>

                            <span>SKU: {selectedItemForReturn?.Sku}</span>
                            <div className="counterdesign">
                              {' '}
                              <span
                                className="text-center"
                                onClick={() => decrementCounter()}
                              >
                                -
                              </span>
                              <span className="text-center">
                                {counter === ''
                                  ? selectedItemForReturn?.Qty
                                  : counter}
                              </span>
                              <span
                                className="text-center"
                                onClick={() => {
                                  incrementCounter(selectedItemForReturn?.Qty);
                                }}
                              >
                                +
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <Row>
                        <Col lg="12">
                          <FormGroup className="mb-3">
                            <AvField
                              type="select"
                              name="rr"
                              label="Return Reason"
                              className="form-select"
                              required
                            >
                              <option value="">Select Option</option>
                              <option value="Out of service">
                                Out of service
                              </option>
                              <option value="Wrong color">Wrong color</option>
                              <option value="Wrong Size">Wrong Size</option>
                              <option value="Not Happy with Product Quality">
                                Not Happy with Product Quality
                              </option>
                              <option value="Wrong installation">
                                Wrong installation
                              </option>
                              <option value="Damage Item Recieved ">
                                Damage Item Recieved
                              </option>
                              <option value="Not Happy with the Product Design">
                                Not Happy with the Product Design
                              </option>
                              <option value="Got a better price">
                                Got a better price
                              </option>
                              <option value="Wrong color">Wrong color</option>
                              <option value="Wrong Size">Wrong Size</option>
                              <option value="Parts Missing">
                                Parts Missing
                              </option>
                              <option value="Wrong Material Delivered">
                                Wrong Material Delivered
                              </option>
                              <option value="Other">Other</option>
                            </AvField>
                          </FormGroup>
                        </Col>
                        <Col lg="12">
                          <FormGroup className="mb-3">
                            <AvField
                              type="select"
                              name="Ic"
                              label="Item Condition"
                              className="form-select"
                              required
                            >
                              <option value="">Select Option</option>
                              <option value=" opened">Opened</option>
                              <option value=" Damaged">Damaged</option>
                              <option value=" Unopened">Unopened</option>
                            </AvField>
                          </FormGroup>
                        </Col>
                        <Col lg="12">
                          <Dropzone
                            onDrop={(acceptedFiles) => {
                              handleAcceptedFiles(acceptedFiles);
                            }}
                          >
                            {({ getRootProps, getInputProps }) => (
                              <div className="dropzone">
                                <div
                                  className="dz-message needsclick mt-2"
                                  {...getRootProps()}
                                >
                                  <input {...getInputProps()} />
                                  <div className="mb-3">
                                    <i className="display-4 text-muted bx bxs-cloud-upload" />
                                  </div>
                                  <h4 style={{ color: '#c0bcbc' }}>
                                    Upload Image Here
                                  </h4>
                                </div>
                              </div>
                            )}
                          </Dropzone>
                          <span className="text-danger">{errorMessage}</span>
                          {imagePreviews && (
                            <div className="mt-2">
                              {imagePreviews.map((img, i) => {
                                return (
                                  <img
                                    alt=""
                                    width="100"
                                    height="100"
                                    className="img-thumbnail"
                                    src={img}
                                    key={i}
                                  />
                                );
                              })}
                            </div>
                          )}
                        </Col>
                      </Row>

                      <Row className="mt-3">
                        <h6 style={{ color: '#495057' }}>Resolution Mode*</h6>
                        <Col>
                          <FormGroup className="mb-3">
                            <Row>
                              {/* <Col>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    value="exchange"
                                    name="payment_mode"
                                    defaultChecked
                                    id="exchangeRadios"
                                    onChange={handlePaymentChange}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="exchangeRadios"
                                  >
                                    Exchange/Repair
                                  </label>
                                </div>
                              </Col> */}
                              {orderDetailReturn?.OrderDetails?.[0]
                                ?.PaymentMode !== 'cashondelivery' &&
                              orderDetailReturn?.OrderDetails?.[0]
                                ?.OrderTotal !== '0.000' &&
                              orderDetailReturn?.OrderDetails?.[0]
                                ?.OrderTotal !== '0.00' ? (
                                <Col>
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      value="Refund"
                                      name="payment_mode"
                                      id="refundRadios"
                                      onChange={handlePaymentChange}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="refundRadios"
                                    >
                                      Refund
                                    </label>
                                  </div>
                                </Col>
                              ) : (
                                ''
                              )}
                              <Col>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    value="wallet"
                                    name="payment_mode"
                                    id="storecreditRadios"
                                    onChange={handlePaymentChange}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="storecreditRadios"
                                  >
                                    Wallet
                                  </label>
                                </div>
                                {/* Conditionally render the message */}
                              </Col>
                            </Row>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        {' '}
                        {paymentMode === 'wallet' && (
                          <div style={{ marginBottom: '10px', color: 'red' }}>
                            Wallet Amount Cannot be Refunded to Card.
                          </div>
                        )}
                      </Row>
                      <Row>
                        <Col lg="12">
                          <FormGroup className="mb-3">
                            <AvField
                              name="return_comment"
                              value=""
                              className="form-control"
                              cols="60"
                              rows="5"
                              type="textarea"
                              required
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <button
                          type="submit"
                          className="btn btn-success"
                          data-toggle="modal"
                        >
                          {updateStsLoad === true && (
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          )}{' '}
                          Submit
                        </button>
                      </Row>
                    </AvForm>
                  </CardBody>
                </Card>
              </ReactDrawer>
            </>
          ) : (
            <>
              {orderDetailReturn?.code === 101 ? (
                <>
                  <div className="orderError">{orderDetailReturn?.message}</div>
                </>
              ) : null}
            </>
          )}
        </Container>
      </div>
      <Toaster position="top-right" reverseOrder={false} />
    </React.Fragment>
  );
};

export default CreateFormReturnWarehouse;
